import DefaultLayout from '@/Layouts/DefaultLayout';
import { lazy } from 'react';
import { LoginRoutes } from '@/features/auth/routes/routes';
import { AuthInitializer } from '@/features/auth/guard/authInitializer';
import { MembersRealtionsRoutes } from '@/features/members/routes/routes';
import { PackagesListRoutes } from '@/features/packages/routes/routes';
import { BranchesRoutes } from '@/features/branch/routes/routes';
import { SettingRoutes } from '@/features/setting/routes/routes';
import { PermissionsRoutes } from '@/features/permissions/routes/routes';
import { ReportsRoutes } from '@/features/reports/routes/routes';
import { FinanceRoutes } from '@/features/finance/routes/routes';
import { NotificationsRoutes } from '@/features/notifications/routes/routes';
import { StudentByTypeRoutes } from '@/features/students_by_type/routes/routes';

// Features
import { SubscriptionRequestRoutes } from '@/features/subscription-requests/routes/routes';
import { ProductsListRoutes } from '@/features/products/routes/routes';
import { EmployeeRoutes } from '@/features/employee/routes/routes';

// ----------------------------------------------------------------------

const Home = lazy(() => import('@/core/global-pages/Home'));
const SoonPage = lazy(() => import('@/core/global-pages/SoonPage'));
const NotFound = lazy(() => import('@/core/global-pages/NotFound'));


// ----------------------------------------------------------------------

const routes = [
    {
        path: '/',
        element: (
            <AuthInitializer>
                <DefaultLayout />
            </AuthInitializer>
        ),
        children: [
            { index: true, element: <Home /> },
            {
                path: '/coming-soon',
                element: <SoonPage />,
                layout: 'default',
                isAuthReq: true,
            },

            ...EmployeeRoutes,
            ...MembersRealtionsRoutes,
            ...SubscriptionRequestRoutes,
            ...ProductsListRoutes,

            ...PackagesListRoutes,
            ...BranchesRoutes,
            ...SettingRoutes,
            ...PermissionsRoutes,
            ...ReportsRoutes,
            ...FinanceRoutes,
            ...NotificationsRoutes,
            ...StudentByTypeRoutes,
            { path: '*', element: <NotFound /> },
        ],
    },
    ...LoginRoutes,
    { path: '*', element: <NotFound /> },
];
export { routes };
